import React from 'react';
import Media from '../../../components/Media/Media';
import { block } from '../../../utils';
import './PreviewMedia.css';
const b = block('preview-media-block');
const PreviewMedia = (props) => {
    const { id, media, play, mods } = props;
    return (React.createElement("div", { key: id, className: b('media', mods) },
        React.createElement(Media, Object.assign({}, media, { playVideo: play }))));
};
export default PreviewMedia;
